import React from 'react'

export default function PreloadImages({images}) {
  return (
    <div>
        {images && images.map((name, idx) => (
            <img src={process.env.REACT_APP_BASENAME + `/img/${name}`} alt="" />
        ))}

    </div>
  )
}
